export default __webpack_public_path__ + "static/media/emoji.2d1cdfa2.gif";